module.exports = __webpack_public_path__ + "img/logo_valle_nevado.e3edf63.svg";


//////////////////
// WEBPACK FOOTER
// ./static/logo_valle_nevado.svg
// module id = vv/a
// module chunks = 1